import { useCallback, useEffect, useRef } from "react";

interface UseInfiniteScrollProps {
    onEndReached: () => void;
    enabled?: boolean;
    rootMargin?: string;
}

export const useInfiniteScroll = ({
    onEndReached,
    enabled = true,
    rootMargin = "200px",
}: UseInfiniteScrollProps) => {
    const observerRef = useRef<IntersectionObserver | null>(null);
    const onEndReachRef = useRef(onEndReached);

    useEffect(() => {
        onEndReachRef.current = onEndReached;
    }, [onEndReached]);

    const sentinelRef = useCallback(
        (node: HTMLDivElement | null) => {
            observerRef.current?.disconnect();
            observerRef.current = null;

            if (!node || !enabled) {
                return
            }

            const observer = new IntersectionObserver(
                ([entry]) => {
                    console.log(
                        'observer',
                        entry.isIntersecting,
                        entry.intersectionRatio
                    );
                    if (entry.isIntersecting) {
                        onEndReachRef.current();
                    }
                },
                { 
                    rootMargin,
                }
            );

            observer.observe(node);

            observerRef.current = observer;
        },
        [enabled, rootMargin]
    );

    useEffect(() => {
        return () => {
            observerRef.current?.disconnect();
        };
    }, []);

    return sentinelRef;
};